import React from 'react';
import PropTypes from 'prop-types';
import { Card, Stack, Typography } from '@curves/ui-base';
import ReadTextField from '@Local/Components/ReadTextField';

/** 商品明細的基本資料卡片（名稱、分類、是否上架） */
const ProductDetailBasicInfoCard = ({ productName, categoryPath, isEnabled }) => (
    <Card className="p-3">
        <Typography variant="h6" className="text-primary font-weight-bold mb-3">
            基本資料
        </Typography>
        <Stack direction="column" spacing={2}>
            <ReadTextField label="商品名稱">{productName || '-'}</ReadTextField>
            <ReadTextField label="商品分類">{categoryPath || '-'}</ReadTextField>
            <ReadTextField label="是否上架">{isEnabled ? '上架' : '下架'}</ReadTextField>
        </Stack>
    </Card>
);

ProductDetailBasicInfoCard.propTypes = {
    productName: PropTypes.string,
    categoryPath: PropTypes.string,
    isEnabled: PropTypes.bool,
};

export default ProductDetailBasicInfoCard;
